import React, { useEffect } from 'react';
import ApiValidationErrorDisplay from '~/components/ApiValidationErrorDisplay';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { schema } from './specialOffer.yup';
import DisplayFormikState from '~/components/DisplayFormikState';
import SubmitResetButtons from '~/components/FormControl/SubmitResetButtons';
import classNames from 'classnames/bind';
const cx = classNames.bind();
import { FormText, FormSelect, TextArea, Selectize, FormNumber } from '~/components/FormControl';
import { Formik } from 'formik';
import { Card, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { FileUploadedWithResetCount } from '~/components/FileUploaded';
import { useNavigate } from 'react-router-dom';
import { SPECIAL_OFFER_TYPE } from '~/config/constants';
import { fetchItemApi } from '~/pages/ItemSaga/Item/itemSlice';

SpecialOfferForm.defaultProps = {
    pictureAttributeNames: null,
};
SpecialOfferForm.propTypes = {
    initialValues: PropTypes.object.isRequired,
    setResetCount: PropTypes.func.isRequired,
    pictureAttributeNames: PropTypes.array,
    resetCount: PropTypes.number.isRequired,
    formSubmit: PropTypes.func.isRequired,
};

function SpecialOfferForm({ initialValues, setResetCount, pictureAttributeNames, resetCount, formSubmit }) {
    const { isLoading } = useSelector((state) => state.loading);
    const { apiValidationErrors } = useSelector((state) => state.apiValidationError);

    const items = useSelector((state) => state.itemSaga.item.rows);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    pictureAttributeNames = ['banner_image'];

    useEffect(() => {
        dispatch(fetchItemApi(navigate));
    }, []);

    return (
        <>
            {/* MUST put `isEmpty(specialOfferMetaData)` in condition, else Bootstrap `Select` will not display value to UI (even though it's already stored value in it)  */}
            {!isEmpty(initialValues) ? (
                <Card>
                    <Card.Body>
                        <Formik
                            initialValues={initialValues}
                            validateOnChange={false}
                            validationSchema={initialValues.id === null ? schema : schema(true)}
                            onSubmit={formSubmit}
                        >
                            {(props) => {
                                // eslint-disable-next-line react/prop-types
                                const { handleSubmit, isSubmitting, resetForm, values, setFieldValue } = props;
                                useEffect(() => {
                                    if (typeof (values.receive_item_id) == 'string') {
                                        try {
                                            console.log(JSON.parse(values.receive_item_id));
                                            setFieldValue('receive_item_id', JSON.parse(values.receive_item_id));
                                        } catch (e) {
                                        }
                                    }
                                }, [values]);
                                return (
                                    <>
                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />

                                        <Form.Row className="d-flex justify-content-between">
                                            <FormSelect
                                                name="offer_type"
                                                options={SPECIAL_OFFER_TYPE}
                                                sm={6}
                                                className="d-flex flex-column justify-content-end"
                                                label="Offer type"
                                            />
                                            {pictureAttributeNames.map((imgName, i) => (
                                                <Col
                                                    key={i}
                                                    sm={6}
                                                >
                                                    <FileUploadedWithResetCount
                                                        pictureName={imgName}
                                                        pictureVal={values[imgName]}
                                                        resetCount={resetCount}
                                                        id={imgName}
                                                    />
                                                </Col>
                                            ))}
                                            <div className="col-sm-3"></div>
                                        </Form.Row>

                                        <Form.Row className="d-flex justify-content-between">
                                            <FormText
                                                name="receive_item_id"
                                                sm={6}
                                                label="Receive item id"
                                            />
                                            <FormText
                                                name={'receive_item_quantity'}
                                                label="Receive item quantity"
                                                sm={6}
                                            />
                                        </Form.Row>

                                        

                                        <Form.Row className="d-flex justify-content-between">
                                            <Selectize
                                                name={'pay_item_id'}
                                                options={items}
                                                label="Pay item id"
                                                sm={6}
                                            />
                                            <FormText
                                                name={'pay_item_quantity'}
                                                label="Pay item quantity"
                                                sm={6}
                                            />
                                        </Form.Row>

                                        <Form.Row className="d-flex justify-content-between">
                                            <FormText
                                                name="from_time"
                                                sm={6}
                                                label="From time"
                                            />
                                            <FormText
                                                name={'to_time'}
                                                label="To time"
                                                sm={6}
                                            />
                                        </Form.Row>
                                        
                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />
                                        <ApiValidationErrorDisplay
                                            errors={apiValidationErrors}
                                            clearError={clearApiValidationErrors}
                                        />
                                        <DisplayFormikState props={props} />
                                    </>
                                );
                            }}
                        </Formik>
                    </Card.Body>
                </Card>
            ) : (
                <Card style={{ position: 'relative' }}>
                    <Card.Body className={cx('row', { whirl: isLoading })}></Card.Body>
                </Card>
            )}
        </>
    );
}

export default SpecialOfferForm;
